import React from "react";
import ReactDOM from "react-dom";
import Routes from './routes';
import mixpanel from 'mixpanel-browser';

mixpanel.init('0ec1a690a04cb3b5f59a17a91fca1e8d', {debug: true}); 
mixpanel.track('Page Load');

ReactDOM.render(<Routes />, document.getElementById('root'));